import { memo } from "react";
import FormCard from "src/components/FormCard";
import { HeightCard } from "src/utils/constants";
import ActionCard from "src/components/ActionCard";
import TextInput from "src/components/TextInput/TextInput";
import { IVariantMetricForm } from "../VariantMetricDetail";
import { UseFormReturnType } from "@mantine/form";
import { IMetricOption } from "src/generated/graphql";
import { IoIosRemoveCircle } from "react-icons/io";
import { useMantineTheme } from "@mantine/core";

interface IMetricOptionProps {
  form: UseFormReturnType<IVariantMetricForm>;
}

const VarientMetricOption = ({ form }: IMetricOptionProps) => {
  const theme = useMantineTheme();
  const ValuesArr = form.getInputProps("values").value;

  const handleAddOption = () => {
    form.insertListItem("values", { name: "" });
  };

  const handleDeleteOption = (index: number) => {
    form.removeListItem("values", index);
  };

  return (
    <>
      <ActionCard
        mt={"md"}
        title="Metric Options"
        handleModal={handleAddOption}
        height={HeightCard.md}
      >
        {ValuesArr?.map((e: IMetricOption, index: number) => (
          <TextInput
            key={e.id || index}
            withAsterisk
            label={"Option Name"}
            rightSection={
              ValuesArr.length > 1 && (
                <IoIosRemoveCircle
                  color={theme.colors.red[6]}
                  size={20}
                  onClick={() => handleDeleteOption(index)}
                />
              )
            }
            {...form.getInputProps(`values.${index}.name`)}
          />
        ))}
      </ActionCard>
    </>
  );
};

export default memo(VarientMetricOption);
